/* tslint:disable */
/* eslint-disable */
/**
 * NLBS SDPS Secure Zone API
 * NLBS SDPS Secure Zone API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KeysResponseBody
 */
export interface KeysResponseBody {
    /**
     * Typesense API key value for downloads collection.
     * @type {string}
     * @memberof KeysResponseBody
     */
    downloadsKey: string;
    /**
     * Typesense API keys expiration Unix date.
     * @type {number}
     * @memberof KeysResponseBody
     */
    expiresAt: number;
    /**
     * Typesense API key value for packages, files and events collections.
     * @type {string}
     * @memberof KeysResponseBody
     */
    packagesKey: string;
}

/**
 * Check if a given object implements the KeysResponseBody interface.
 */
export function instanceOfKeysResponseBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "downloadsKey" in value;
    isInstance = isInstance && "expiresAt" in value;
    isInstance = isInstance && "packagesKey" in value;

    return isInstance;
}

export function KeysResponseBodyFromJSON(json: any): KeysResponseBody {
    return KeysResponseBodyFromJSONTyped(json, false);
}

export function KeysResponseBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): KeysResponseBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'downloadsKey': json['downloads_key'],
        'expiresAt': json['expires_at'],
        'packagesKey': json['packages_key'],
    };
}

export function KeysResponseBodyToJSON(value?: KeysResponseBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'downloads_key': value.downloadsKey,
        'expires_at': value.expiresAt,
        'packages_key': value.packagesKey,
    };
}

